import styled from 'libs/styled';

const Stop = styled('Stop')``;

export default Stop;
